define(["require", "exports", "tslib", "./DirectiveJustify"], function (require, exports, tslib_1, DirectiveJustify_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    DirectiveJustify_1 = (0, tslib_1.__importDefault)(DirectiveJustify_1);
    var SPACE = "\u200A";
    function splitText(_a) {
        var ctx = _a.ctx, text = _a.text, justify = _a.justify, width = _a.width;
        var textMap = new Map();
        var measureText = function (text) {
            var width = textMap.get(text);
            if (width !== undefined) {
                return width;
            }
            width = ctx.measureText(text).width;
            textMap.set(text, width);
            return width;
        };
        var textArray = [];
        var initialTextArray = text.split('\n');
        var spaceWidth = justify ? measureText(SPACE) : 0;
        var index = 0;
        var averageSplitPoint = 0;
        for (var _i = 0, initialTextArray_1 = initialTextArray; _i < initialTextArray_1.length; _i++) {
            var singleLine = initialTextArray_1[_i];
            var textWidth = measureText(singleLine);
            var singleLineLength = singleLine.length;
            if (textWidth <= width) {
                textArray.push(singleLine);
                continue;
            }
            var tempLine = singleLine;
            var splitPoint = void 0;
            var splitPointWidth = void 0;
            var textToPrint = '';
            while (textWidth > width) {
                index++;
                splitPoint = averageSplitPoint;
                splitPointWidth =
                    splitPoint === 0 ? 0 : measureText(singleLine.substring(0, splitPoint));
                if (splitPointWidth < width) {
                    while (splitPointWidth < width && splitPoint < singleLineLength) {
                        splitPoint++;
                        splitPointWidth = measureText(tempLine.substring(0, splitPoint));
                        if (splitPoint === singleLineLength)
                            break;
                    }
                }
                else if (splitPointWidth > width) {
                    while (splitPointWidth > width) {
                        splitPoint = Math.max(1, splitPoint - 1);
                        splitPointWidth = measureText(tempLine.substring(0, splitPoint));
                        if (splitPoint === 1)
                            break;
                    }
                }
                averageSplitPoint = Math.round(averageSplitPoint + (splitPoint - averageSplitPoint) / index);
                splitPoint--;
                if (splitPoint > 0) {
                    var tempSplitPoint = splitPoint;
                    if (tempLine.substring(tempSplitPoint, tempSplitPoint + 1) !== ' ') {
                        while (tempSplitPoint >= 0
                            && tempLine.substring(tempSplitPoint, tempSplitPoint + 1) !== ' ') {
                            tempSplitPoint--;
                        }
                        if (tempSplitPoint > 0) {
                            splitPoint = tempSplitPoint;
                        }
                    }
                }
                if (splitPoint === 0) {
                    splitPoint = 1;
                }
                textToPrint = tempLine.substring(0, splitPoint);
                textToPrint = justify
                    ? (0, DirectiveJustify_1.default)({
                        ctx: ctx,
                        line: textToPrint,
                        spaceWidth: spaceWidth,
                        spaceChar: SPACE,
                        width: width
                    })
                    : textToPrint;
                textArray.push(textToPrint);
                tempLine = tempLine.substring(splitPoint);
                textWidth = measureText(tempLine);
            }
            if (textWidth > 0) {
                textToPrint = justify
                    ? (0, DirectiveJustify_1.default)({
                        ctx: ctx,
                        line: tempLine,
                        spaceWidth: spaceWidth,
                        spaceChar: SPACE,
                        width: width
                    })
                    : tempLine;
                textArray.push(textToPrint);
            }
        }
        return textArray;
    }
    exports.default = splitText;
});
//# sourceMappingURL=DirectiveSplitText.js.map